import iconRightArrow from '@image/icon_arrow_right.svg';
import { BaseComponent } from './baseComponent';

export class OfferInfoWindowListItem extends BaseComponent {
  static readonly tagName = 'offer-info-window-list-item';
  static readonly checkAttributes = ['title', 'has-myshift', 'hourly-pay', 'has-bonus', 'bonus-rate', 'link'];

  constructor(params?: {
    title?: string;
    hasMyshift?: boolean;
    hourlyPay?: number;
    hasBonus?: boolean;
    bonusRate?: number | null;
    link?: string
    }
  ) {
    super();
    if (params?.title) {
      this.setAttribute('title', params.title);
    }

    if (params?.hasMyshift) {
      this.setAttribute('has-myshift', params.hasMyshift.valueOf() ? 'true' : 'false');
    }

    if (params?.hourlyPay) {
      this.setAttribute('hourly-pay', params.hourlyPay.toString());
    }

    if (params?.hasBonus) {
      this.setAttribute('has-bonus', params.hasBonus.valueOf() ? 'true' : 'false');
    }

    const bonusRate = params?.bonusRate;
    if (typeof bonusRate === 'number' && bonusRate > 0) {
      this.setAttribute('bonus-rate', bonusRate.toString());
    }

    if (params?.link) {
      this.setAttribute('link', params.link);
    }
  }

  protected reader() {
    const title = this.getAttribute('title') || '';
    const hasMyshift = this.getAttribute('has-myshift') === 'true';
    const bonusRate = Number(this.getAttribute('bonus-rate') || 0);
    const hasBonus = bonusRate > 0;
    const hourlyPay = this.getAttribute('hourly-pay') || '0';
    const link = this.getAttribute('link') || '#';

    this.classList.add('flex', 'pt-4', 'pb-2');

    let myshiftHtml = ``;

    if (hasMyshift) {
      myshiftHtml = `
        <div class="w-fit flex min-h-5 px-1 py-0.5 bg-primary rounded-[4px] justify-center items-center overflow-hidden text-center text-white font-semibold text-xs">
          マイシフト対応
        </div>
      `.trim();
    }

    let bonusHtml = ``;
    if (hasBonus) {
      bonusHtml = `
        <div class="w-fit flex min-h-5 px-1 py-0.5 bg-error justify-center items-center text-center text-white font-semibold text-sm">
          ${bonusRate}%UP
        </div>
      `.trim();
    }

    const hourlyPayHtml = `<span class="leading-5 flex items-baseline gap-x-1 ${hasBonus ? 'text-error' : 'text-lightblack'}"><span class="text-xs">時給</span>¥${hourlyPay.toLocaleString()}</span>`;

    this.innerHTML = `
      <a tabindex="-1" class="text-lightblack w-full flex items-stretch" data-turbo-frame="_top" href="${link}">
        <div class="flex min-w-0 flex-1 flex-col justify-start gap-y-1">
          ${myshiftHtml}
          <span class="text-lg font-normal">${title}</span>
          ${bonusHtml}
          ${hourlyPayHtml}
        </div>
        <div class="ml-auto flex w-8 shrink-0 items-center justify-end">
          <img src="${iconRightArrow}" class="h-5 w-5 object-contain">
        </div>
      </a>
    `.trim();
  }
}
